<template>
  <b-form @submit="onSubmit" @reset="onReset" layout="vertical">
    <div class="row">
      <a-form-item label="Name" class="col-md-3">
        <b-input
          name="name"
          placeholder="Name"
          v-model="filterForm.name"
        ></b-input>
      </a-form-item>
      <a-form-item label="Document" class="col-md-3">
        <b-input
          name="document"
          placeholder="Document"
          v-model="filterForm.document"
        ></b-input>
      </a-form-item>
      <a-form-item label="Email" class="col-md-3">
        <b-input
          name="email"
          placeholder="Email"
          v-model="filterForm.email"
        ></b-input>
      </a-form-item>
      <a-form-item label="FgActive" class="col-md-3">
        <a-select v-model="filterForm.fgActive">
          <a-select-option :value="false">
            Não
          </a-select-option>
          <a-select-option :value="true">
            Sim
          </a-select-option>
        </a-select>
      </a-form-item>
    </div>
    <div>
      <b-button class="ml-2" type="reset">Reverter</b-button>
      <b-button type="submit" variant="outline-primary" class="ml-2">Buscar</b-button>
    </div>
  </b-form>
</template>

<script>
export default {
  data() {
    return {
      fgActionOptions: [
        { value: null, text: 'FgActive', disabled: true },
        { value: 'true', text: 'True' },
        { value: 'false', text: 'False' },
      ],
      filterForm: {
        name: this.$route.query.name || '',
        document: this.$route.query.document || '',
        email: this.$route.query.email || '',
        fgActive: this.$route.query.fgActive || null,
      },
    }
  },
  methods: {
    onReset() {
      Object.keys(this.filterForm).forEach((item) => {
        this.filterForm[item] = item === 'fgActive' ? null : ''
      })
    },

    onSubmit(e) {
      e.preventDefault()
      let queryObject = {}
      Object.keys(this.filterForm).forEach((item) => {
        if (this.filterForm[item]) {
          queryObject[item] = this.filterForm[item]
        }
      })

      let query = {
        ...queryObject,
        page: 1,
      }
      this.$router.push({ query })
    },
  },
}
</script>
